import React from 'react';
import { ChatChannel } from '../../../models/ChatChannel';
import { ChatChannelUser } from '../../../models/ChatChannelUser';
import { ChatChannelGroup } from '../../../models/ChatChannelGroup';
import { Pleb } from '../../../models/Pleb';
import { Event } from '../../../models/Event';

interface ChatAvatarProps {
  channel?: ChatChannel;
  user?: Pleb
  event?: Event
  size?: number;
  loading?: 'lazy' | 'eager';
  showBorder?: boolean;
}

export const ChatAvatar: React.FC<ChatAvatarProps> = ({ 
  channel, 
  user,
  event,
  loading,
  size = 48,
  showBorder = false,
}) => {  
  const getBorderClasses = (): string => {
    if(!showBorder)
      return '';
    if(user)
      return '';
    if(event)
      return '';
    if (channel instanceof ChatChannelUser && channel.merchant) {
      return 'p-[2px] bg-gradient-to-b from-brand-blue to-brand-light-blue';
    }
    if (channel instanceof ChatChannelGroup) {
      return 'p-[2px] bg-gradient-to-b from-brand-orange to-brand-light-orange';
    }
    return '';
  };

  const image = user?.thumbnail || channel?.image || event?.thumbnail;

  return (
    <div 
      className={`relative rounded-full overflow-hidden shrink-0 ${getBorderClasses()}`}
      style={{ width: size, height: size }}
    >
      {image ? (
        <img
          src={image}
          alt="Avatar"
          className="w-full h-full object-cover rounded-full overflow-hidden bg-white"
          loading={loading ?? 'lazy'}
        />
      ) : (
        <div className="w-full h-full bg-gray-300 rounded-full overflow-hidden" />
      )}
    </div>
  );
};
